import React, { Component, Fragment } from 'react';
import { isEmpty, size } from "lodash"

import { newPayment } from '../../../store/actions/paymentAction'

import { 
    Grid ,
    Button ,
    Slide, 
    Box,
    Typography,
} from '@mui/material';

import DatePicker from '../../common/DatePicker';
import ReceivePayment from './ReceivePayment';
import InputText, { InputSelectNative, TextArea } from '../../common/Form';
import Dialog from '../../common/Dialog';
import SalaryReceivePayment from './SalaryReceivePayment';
import ChargeReceivePayment from './ChargeReceivePayment';
import { MONTHS } from '../../../utils/generalFuncs';
import PaymentLine from './PaymentLine';
import { AddRounded, AddCircleOutlineRounded } from '@mui/icons-material';
import PaymentLineSingleFullAdvance from './PaymentLineSingleFullAdvance';
import Currency from '../../common/Currency';
import { SingleCheckbox } from '../../common/RadioAndCheckbox';

class PaymentForm extends Component {
    state = { 
        payment_total_amount : this.props.payment ? this.props.payment.payment_total_amount : "",
        payment_desc : this.props.payment ? this.props.payment.payment_desc : "",
        payment_remarks: this.props.payment ? this.props.payment.payment_remarks : "",
        payment_bank: this.props.payment ? this.props.payment.payment_bank : "",
        payment_mode: this.props.payment ? this.props.payment.payment_mode : "",
        payment_ref: this.props.payment ? this.props.payment.payment_ref : "",
        payment_date: this.props.payment ? this.props.payment.payment_date : new Date(),
        isFullAdvance: false,
        showOptFullAdvance: false,
        payments: [
            {
                payment_spending_id: "",
                payment_spending_idDisplay: {value: "", label:""},
                payment_amount: "",
                payment_advance_amount: "",
                payment_details_supplier: "",
            }
        ],
        errors:{
            payment_total_amount: "",
            payment_bank: "",
            payment_mode: "",
            payment_date: "",
            payments: [
                {
                    payment_spending_id: "",
                    payment_amount: "",
                }
            ],
        },
        filteredSpendings: {},
        filteredSalaries: {},
        filteredCharges: {},
        open: false,
    }
    componentDidMount() {
        const { SPENDINGS, spendings, update, CHARGES, charges, SALARIES, salaries, EMPLOYEES, SALARY_CATS, SUPPLIERS  } = this.props;
        let payments = []
        let errors = []
        let filteredSpendings = {}
        let filteredCharges = {}
        let filteredSalaries = {}
        let payment_mode = this.state.payment_mode
        let payment_total_amount = ""
        let showOptFullAdvance = false 

        let tmpArr = Object.values(SPENDINGS).filter( item => !item.spending_fully_paid && item.spending_status === "VALIDATE")
        tmpArr.map( item => {
            filteredSpendings[item.spending_id] = item
        })

        tmpArr = Object.values(CHARGES).filter( item => !item.salary_line_fully_paid )
        tmpArr.map( item => {
            filteredCharges[item.salary_line_id] = item
        })

        tmpArr = Object.values(SALARIES).filter( item => !item.salary_fully_paid )
        tmpArr.map( item => {
            filteredSalaries[item.salary_id] = item
        })

        if ( !isEmpty(SPENDINGS) && !isEmpty(spendings) && !update ){
            spendings.map( spendID => {
                let spend = SPENDINGS[spendID]
                let advance_amount = spend ? SUPPLIERS[spend.spending_supplier].supplier_account : 0
                if (advance_amount > 0) {
                // if (spend.spending_rest_to_pay <= advance_amount) {
                    advance_amount = spend.spending_rest_to_pay
                    // payment_mode = "COLLAB" // to hide useless fields
                    payment_total_amount = advance_amount
                    showOptFullAdvance = true
                }
                payments.push({
                    payment_spending_id: spendID,
                    payment_spending_idDisplay: {
                        value: spendID, 
                        label: 
                            spend ? 
                            `${new Date(spend.spending_date).toLocaleDateString("fr-FR") } | ${spend.spending_desc} |  ${spend.spending_amountTTC.toLocaleString("fr-FR")}` :
                            ""
                    },
                    payment_amount: spend ? spend.spending_rest_to_pay : "",
                    payment_advance_amount : advance_amount,
                    total_advance: advance_amount,
                    // payment_advance_amount : spend ? SUPPLIERS[spend.spending_supplier].supplier_account : "",
                    payment_details_supplier : spend ? spend.spending_supplier : "",
                    
                })
                errors.push({
                    payment_spending_id: "",
                    payment_amount: "",
                })
            })
        }

        if ( !isEmpty(SALARIES) && !isEmpty(salaries) ){
            salaries.map( salaryID => {
                payments.push({
                    payment_salary_id: salaryID,
                    payment_salary_idDisplay: {
                        value: salaryID, 
                        label: 
                            SALARIES[salaryID] ? 
                            `${new Date(SALARIES[salaryID].salary_date).toLocaleDateString("fr-FR") } | Salaire ${ MONTHS[new Date(SALARIES[salaryID].salary_period_end).getMonth()]} ${new Date(SALARIES[salaryID].salary_period_end).getFullYear() } - ${ SALARIES[salaryID].salary_employee && 
                                EMPLOYEES[SALARIES[salaryID].salary_employee].employee_lastname
                            } ${ SALARIES[salaryID].salary_employee && 
                                EMPLOYEES[SALARIES[salaryID].salary_employee].employee_firstname
                            } | ${SALARIES[salaryID].salary_to_pay.toLocaleString("fr-FR")}` :
                            ""
                    },
                    payment_amount: SALARIES[salaryID] ? SALARIES[salaryID].salary_rest_to_pay : "",
                    payment_is_salary: true,

                })
                errors.push({
                    payment_salary_id: "",
                    payment_amount: "",
                })
            })
        }

        if ( !isEmpty(CHARGES) && !isEmpty(charges) ){
            charges.map( chargeID => {
                payments.push({
                    payment_charge_id: chargeID,
                    payment_charge_idDisplay: {
                        value: chargeID, 
                        label: 
                            CHARGES[chargeID] ? 
                            `${new Date(CHARGES[chargeID].salary_line_date).toLocaleDateString("fr-FR") } | ${
                                CHARGES[chargeID].salary_line_name && SALARY_CATS[CHARGES[chargeID].salary_line_name].salary_cat_name
                            } - ${ CHARGES[chargeID].salary_line_employee && 
                                EMPLOYEES[CHARGES[chargeID].salary_line_employee].employee_lastname
                            } ${ CHARGES[chargeID].salary_line_employee && 
                                EMPLOYEES[CHARGES[chargeID].salary_line_employee].employee_firstname
                            } | ${CHARGES[chargeID].salary_line_retenue.toLocaleString("fr-FR")}` :
                            ""
                    },
                    payment_amount: CHARGES[chargeID] ? CHARGES[chargeID].salary_line_rest_to_pay : "",
                    payment_is_charge: true,

                })
                errors.push({
                    payment_charge_id: "",
                    payment_amount: "",
                })
            })
        }

        this.setState({
            payments,
            errors:{
                ...this.state.errors,
                payments:errors,
            },
            filteredSpendings,
            filteredSalaries,
            filteredCharges,
            payment_mode,
            payment_total_amount,
            showOptFullAdvance,
        })
    }
    // FORM
    handleChange = (e) => {

        const name = e.target.name
        const value = e.target.value
        const regexF = /^[-+]?[0-9]*\.?[0-9]+$/ // accept negatives
        // const regexF = /^(?[0-9]+([.][0-9]*)?|[.][0-9]+)$/
        const floatFields = [ "payment_total_amount"]

        if (!floatFields.includes(name) ){
            this.setState({
                [name]: value
            })
        } else if (floatFields.includes(name) && (regexF.test(value) || value === "")){
            this.setState({
                [name]: value
            })
        }
    }

    handleChangePayments = (name, value, index) => {
        console.log('=========== handleChangePayments ===============');
        console.log({name, value, index});
        
        let cpPayments = [].concat(this.state.payments)   
        cpPayments[index][name] = value 
        console.table(cpPayments);

        this.setState({
            ...this.state,
            payments: cpPayments
        })
    }
    handleChangeCreatable = (option, name, index) => {
        let cpPayments = [].concat(this.state.payments) 
        if(option){         
            cpPayments[index][name] = option.value
            cpPayments[index][`${name}Display`] = option
        } else {
            cpPayments[index][name] = ""
            cpPayments[index][`${name}Display`] = {label: "", value: ""}
        }
        this.setState({
            ...this.state,
            payments: cpPayments
        })
    }
    handleChangeDate = (date) => {        
        this.setState({
            payment_date: date
        })
    }
    handleAddForm = (type = "SPENDING") => { // or SALARY OR CHARGE
        if ( type === "SPENDING" ){
            this.setState({
                payments: [
                    ...this.state.payments,
                    {
                        payment_spending_id: "",
                        payment_spending_idDisplay: {value: "", label:""},
                        payment_amount: "",
                        payment_advance_amount: "",
                    }
                ],
                errors: {
                    ...this.state.errors,
                    payments:[
                        ...this.state.errors.payments,{
                            payment_spending_id: "",
                            payment_amount: "",
                            // payment_advance_amount: "",
                        } 
                    ]
                },
            })
        } else if ( type === "SALARY" ){
            this.setState({
                payments: [
                    ...this.state.payments,
                    {
                        payment_salary_id: "",
                        payment_salary_idDisplay: {value: "", label:""},
                        payment_amount: "",
                        payment_is_salary: true,
                    }
                ],
                errors: {
                    ...this.state.errors,
                    payments:[
                        ...this.state.errors.payments,{
                            payment_salary_id: "",
                            payment_amount: "",
                        } 
                    ]
                },
            })
        } else if ( type === "CHARGE" ){
            this.setState({
                payments: [
                    ...this.state.payments,
                    {
                        payment_charge_id: "",
                        payment_charge_idDisplay: {value: "", label:""},
                        payment_amount: "",
                        payment_is_charge: true,
                    }
                ],
                errors: {
                    ...this.state.errors,
                    payments:[
                        ...this.state.errors.payments,{
                            payment_charge_id: "",
                            payment_amount: "",
                        } 
                    ]
                },
            })
        } 
    }
    createAddForm = () => {
        const { payments, filteredSpendings, filteredCharges, filteredSalaries } = this.state
        
        let selected = payments.map( item => item.payment_spending_id || item.payment_salary_id || item.payment_charge_id)
        console.log('====================================');
        console.log({selected});
        console.log('====================================');
        let tab = []
        let total = 0
        for(let i = 0; i < size(payments); i++){
            total += this.state.payments[i].payment_amount
            let type = ""
            let salary = {}
            let charge = {}
            let spending = {}
            
            if( this.state.payments[i].payment_spending_id ) {
                type = "spending"
                spending = filteredSpendings[payments[i].payment_spending_id]
            } else if ( this.state.payments[i].payment_salary_id ) {
                type = "salary"
                salary = filteredSalaries[payments[i].payment_salary_id]
            } else if ( this.state.payments[i].payment_charge_id ) {
                type = "charge"
                charge = filteredCharges[payments[i].payment_charge_id]
            }
            if (this.state.payment_mode === "COLLAB" && !this.props.update) { // used for advance supplier payment
                tab.push(
                    <PaymentLineSingleFullAdvance
                        {...this.state.payments[i]}
                        SPENDINGS={filteredSpendings}
                        SUPPLIERS={this.props.SUPPLIERS}
                        selected={selected}
                        spending={spending}
                        type={type}
                        errors={this.state.errors.payments[i]} 
                        handleChange={this.handleChangePayments} 
                        handleChangeCreatable={this.handleChangeCreatable} 
                        index={i} 
                    />
                )
            } else {
                tab.push(
                    <PaymentLine
                        {...this.state.payments[i]}
                        CHARGES={filteredCharges}
                        SALARIES={filteredSalaries}
                        SPENDINGS={filteredSpendings}
                        SALARY_CATS={this.props.SALARY_CATS}
                        EMPLOYEES={this.props.EMPLOYEES}
                        SUPPLIERS={this.props.SUPPLIERS}
                        selected={selected}
                        salary={salary}
                        charge={charge}
                        spending={spending}
                        type={type}
                        errors={this.state.errors.payments[i]} 
                        handleChange={this.handleChangePayments} 
                        handleChangeCreatable={this.handleChangeCreatable} 
                        deleteLine={this.deleteLine} 
                        index={i} 
                    />
                )
            }
        }
        return {tab, total}
    }

    deleteLine = (index) => {
        this.setState({
            payments: [
                ...this.state.payments.slice(0,index),
                ...this.state.payments.slice(index +1),
            ],
            errors: {
                ...this.state.errors,
                payments:[
                    ...this.state.errors.payments.slice(0,index),
                    ...this.state.errors.payments.slice(index +1),
                ]
            },
        })

    }

    validatePayments = () => {
        const { SPENDINGS, SALARIES, CHARGES } = this.props;
        let payments = [].concat(this.state.payments)
        let required = [
            // "payment_amount",
            // "payment_spending_id",
        ]
        if (this.state.payment_mode !== "COLLAB" ) {
            required.push("payment_amount")
        } else {
            required.push("payment_advance_amount")
        }

        let errors = [].concat(this.state.errors.payments)
        let noError = true

        let total = 0
        payments.forEach( (pay, index) => {
            required.forEach(field => {
                if( isEmpty(pay[field]) && !pay[field] ) { 
                    console.log(`${field} is empty`)
                    noError = false
                    errors[index][field] = "Veuillez remplir ce Champ" 
                } else {
                    errors[field] = "" 
                }
            })

            if( !pay.payment_is_salary && !pay.payment_is_charge ) {
                if(!pay.payment_spending_id){
                    noError = false
                    errors[index].payment_spending_id = "Veuillez remplir ce Champ"
                } else {
                    let spending = SPENDINGS[pay.payment_spending_id]
                    if (spending) {
                        if (spending.spending_rest_to_pay < pay.payment_amount){
                            errors[index].payment_amount = `Reste à payer : ${spending.spending_rest_to_pay}`
                            noError = false
                        } else {
                            errors[index].payment_amount = ""
                            // payment_details_supplier : spending ? spending.spending_supplier : "",
                        }
                    }
                }
            } else if ( pay.payment_is_salary ) {
                if(!pay.payment_salary_id){
                    noError = false
                    errors[index].payment_is_salary = "Veuillez remplir ce Champ"
                } else {
                    let salary = SALARIES[pay.payment_salary_id]
                    if (salary) {
                        if (salary.salary_rest_to_pay < pay.payment_amount){
                            errors[index].payment_amount = `Reste à payer : ${salary.salary_rest_to_pay}`
                            noError = false
                        } else {
                            errors[index].payment_amount = ""
                        }
                    }
                }
                
            } else if ( pay.payment_is_charge ) {
                if(!pay.payment_charge_id){
                    noError = false
                    errors[index].payment_is_charge = "Veuillez remplir ce Champ"
                } else {
                    let charge = CHARGES[pay.payment_charge_id]
                    if (charge) {
                        if (charge.salary_line_rest_to_pay < pay.payment_amount){
                            errors[index].payment_amount = `Reste à payer : ${charge.salary_line_rest_to_pay}`
                            noError = false
                        } else {
                            errors[index].payment_amount = ""
                        }
        
                    }
                }
            }
            if (this.state.payment_mode !== "COLLAB" ) {
                total += pay.payment_amount
            } else {
                total += pay.payment_advance_amount
            }
        })
        return {
            noError, errors, total
        }
    }
    validate = () => {
        let required = [
            "payment_date",
            "payment_total_amount",
            "payment_bank",
            "payment_mode",
            "payment_ref",
        ]
        let validPayments = this.validatePayments()
        let noError = validPayments.noError
        let errors = [].concat(this.state.errors)
        errors.payments = validPayments.errors
        
        
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
        
        if (parseFloat(this.state.payment_total_amount) !== parseFloat(validPayments.total) ){
            noError = false
            errors.payment_total_amount = "Le total ne correspond pas"
        }
        this.setState({
            errors
        })
        return noError
    }
    validateAdvance = () => {
        let required = [
            "payment_date",
        ]
        
        let validPayments = this.validatePayments()
        let noError = validPayments.noError
        let errors = [].concat(this.state.errors)        
        errors.payments = validPayments.errors
        
        
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
    
        this.setState({
            errors
        })
        return {noError, total: validPayments.total}
    }
    handleSubmit = async () => {
        if ( (this.state.payment_mode !== "COLLAB" && this.validate()) )  {
            let data = {}
            data.payment_date = this.state.payment_date
            data.payment_update_date = new Date()
            data.payment_total_amount =  parseFloat(this.state.payment_total_amount)
            data.payment_mode =  this.state.payment_mode
            data.payment_bank =  this.state.payment_bank
            data.payment_ref =  this.state.payment_ref
            data.payment_remarks =  this.state.payment_remarks
            data.payments_spendings =  this.state.payments
            
            console.log('====================================');
            console.log("submit payment", {data});
            console.log('====================================');
            await this.props.newPayment(data)

            // // if NoErrors ...
            if(this.props.STATE.payments.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.payments.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else if (this.state.payment_mode === "COLLAB" && this.validateAdvance().noError )  {
            let data = {}
            data.payment_date = this.state.payment_date
            data.payment_update_date = new Date()
            data.payment_total_amount =  parseFloat(this.validateAdvance().total)
            data.payment_remarks = this.state.payment_remarks
            data.payments_spendings = this.state.payments
            
            console.log('====================================');
            console.log("submit payment advance", {data});
            console.log('====================================');
            await this.props.newPaymentFullSupplier(data)

            // // if NoErrors ...
            if(this.props.STATE.payments.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.payments.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }

        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    validateUpdate = () => {
        let required = [
            "payment_date",
            "payment_bank",
            "payment_mode",
            "payment_ref",
        ]

        let noError = true
        let errors = [].concat(this.state.errors)        

        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
    
        this.setState({
            errors
        })
        return noError
    }
    handleUpdate = async () => {

        if( this.validateUpdate() ){
            let data = this.props.payment
            data.payment_date = this.state.payment_date
            data.payment_update_date = new Date()
            data.payment_mode =  this.state.payment_mode
            data.payment_bank =  this.state.payment_bank
            data.payment_ref =  this.state.payment_ref
            data.payment_remarks =  this.state.payment_remarks
            
            console.log('====================================');
            console.log("submit update payment", {data});
            console.log('====================================');
            await this.props.updatePayment(data)

            // // if NoErrors ...
            if(this.props.STATE.payments.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.payments.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        console.log("New payment PROPS", this.props);
        
        const { BANKS, update } = this.props;
        const {showOptFullAdvance, isFullAdvance } = this.state;

        const { tab, total } = this.createAddForm();

        return (                
            <Dialog
                close={this.props.handleClose}
                fullScreen={!update}
                maxWidth={update && "md"}
                appBar
                title={update ? "Modifier" : "Nouveau Paiement"}
                submitAction={this.props.update ? this.handleUpdate : this.handleSubmit}
                disabledSubmit={this.props.STATE.payments.fetching}
            >
                <Grid container spacing={3}>
                    <Grid container item xs={12} sm={6}>
                        <Grid item xs={12}>
                            <DatePicker  
                                id="payment_date"
                                label="Date de Paiement"
                                name="payment_date"
                                value={this.state.payment_date}
                                error={this.state.errors.payment_date}
                                handleChange={this.handleChangeDate} 
                                required
                            />
                        </Grid>
                        {showOptFullAdvance &&
                            <Grid item xs={12}>
                                <Box p={1}>
                                    <SingleCheckbox
                                        label="Acompte Seul"
                                        checked={isFullAdvance}
                                        onChange={(e) => this.setState({isFullAdvance: e.target.checked, payment_mode: (e.target.checked ? "COLLAB" : "") })}
                                    />
                                </Box>
                            </Grid>
                        }

                        {this.state.payment_mode !== "COLLAB" &&
                        <Grid item xs={12}>
                            <InputText
                                required
                                disabled={update}
                                onChange={!update && this.handleChange}
                                name="payment_total_amount" 
                                id="payment_total_amount" 
                                value={this.state.payment_total_amount} 
                                label="Montant Payé" 
                                error={this.state.errors.payment_total_amount}
                            />
                            {total != 0 &&
                                <Box p={1}>
                                    <Typography variant="subtitle" color="primary">Total entré: <Currency value={total} /></Typography>
                                </Box>
                            }
                        </Grid>    
                        }      
                        {this.state.payment_mode !== "COLLAB" && // for update
                        <Fragment>
                            <Grid item xs={12}>
                                <InputSelectNative
                                    value={this.state.payment_mode}
                                    onChange={this.handleChange}
                                    labelWidth={170} 
                                    name="payment_mode" 
                                    id="payment_mode"
                                    label="Mode de Paiement"
                                    required 
                                    error={this.state.errors.payment_mode}
                                    options={[
                                        <option value="ESPECES">ESPECES</option>,
                                        <option value="CHEQUE">CHEQUE</option>,
                                        <option value="PRELEVEMENT">PRELEVEMENT</option>,
                                        <option value="VIREMENT">VIREMENT</option>,
                                        <option value="GAB">GAB</option>,
                                        <option value="MOBILE MONEY">MOBILE MONEY</option>,
                                    ]}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <InputText
                                    onChange={this.handleChange}
                                    required
                                    id="payment_ref"
                                    error={this.state.errors.payment_ref}
                                    value={this.state.payment_ref}
                                    name="payment_ref"
                                    label="Réference Paiement"
                                />
                            </Grid>
                        </Fragment>
                        }
                            
                    </Grid>
                    <Grid container item xs={12} sm={6}>
                        {this.state.payment_mode !== "COLLAB" &&
                            <Grid item xs={12} >
                                <InputSelectNative
                                    label="Banque"
                                    onChange={this.handleChange}
                                    error={this.state.errors.payment_bank}
                                    value={this.state.payment_bank}
                                    name="payment_bank" 
                                    labelWidth={60} 
                                    id="payment_bank" 
                                    options={ Object.values(BANKS).map( bank  => (
                                        <option value={bank.bank_id} key={bank.bank_id}>
                                            {bank.bank_name}
                                        </option>
                                    )) }
                                />      
                            </Grid>                                    
                        }
                        <Grid item xs={12} >
                            <TextArea
                                onChange={this.handleChange}
                                rows={this.state.payment_mode !== "COLLAB" ? 10 : 7}
                                name="payment_remarks" 
                                id="payment_remarks" 
                                value={this.state.payment_remarks} 
                                label="Remarques" 
                            />
                        </Grid>
                    </Grid>                                     
                </Grid>
                {!update && 
                    <Grid>
                        {tab}
                        {this.state.payment_mode !== "COLLAB" &&
                            <Grid container spacing={2} item xs={12} style={{ textAlign: "center" }}>
                                <Grid item xs={12} sm={4}>
                                    <Button startIcon={<AddCircleOutlineRounded />} variant="contained" onClick={() => this.handleAddForm("SPENDING")} style={{ color:"black", background: "lightblue"}}>
                                    Dépense
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Button startIcon={<AddCircleOutlineRounded />} variant="contained" onClick={() => this.handleAddForm("SALARY")} style={{ color:"black", background: "#fbfbaa"}}>
                                    Salaire
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Button startIcon={<AddCircleOutlineRounded />} variant="contained" onClick={() => this.handleAddForm("CHARGE")} style={{ color:"black", background: "lightpink"}}>
                                    Charge
                                    </Button>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                }                                  
            </Dialog>
        )
    }
}

export default PaymentForm;